import { render } from "./docversionpopup.vue?vue&type=template&id=63d9d1ec&scoped=true"
import script from "./docversionpopup.vue?vue&type=script&lang=js"
export * from "./docversionpopup.vue?vue&type=script&lang=js"

import "./docversionpopup.vue?vue&type=style&index=0&id=63d9d1ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d9d1ec"]])

export default __exports__